import { useIpDataStore } from '~/stores/ipData';

const ipDataCookieConfig = {
  maxAge: 60 * 60 * 24, // 1 day
  sameSite: 'lax',
  path: '/',
};

export default defineNuxtPlugin(async (nuxtApp) => {
  const ipDataStore = useIpDataStore(nuxtApp.$pinia);
  const ipDataCookie = useCookie('ipData', ipDataCookieConfig);

  let ipAddress = null;
  if (import.meta.env.SSR) {
    const headers = useRequestHeaders();

    if (headers['x-forwarded-for']) {
      ipAddress = headers['x-forwarded-for'].split(',')[0];
    }
  }

  if (ipDataCookie.value) {
    ipDataStore.setData(ipDataCookie.value);
    return;
  }

  const { ipApiAccessToken } = useRuntimeConfig().public;

  await ipDataStore.fetch(ipAddress, ipApiAccessToken);

  if (ipDataStore.ipData) {
    ipDataCookie.value = ipDataStore.ipData;
  }
});
